import { Link } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import ValphaLogo from "../branding/logo";

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-[#0F1826] text-white font-inter px-4 py-8 flex items-center justify-center">
      <div className="w-full max-w-sm text-center">
        <img
          src={ValphaLogo}
          alt="valpha.io"
          className="mx-auto h-20 w-auto object-contain"
        />
        <h1 className="mt-6 text-3xl font-semibold tracking-tight">valpha.io</h1>
        <p className="mt-2 text-sm text-[#A9B7CA]">Private access only.</p>

        <div className="mt-8 grid gap-3">
          <Link
            to="/login"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-[#4FA9A1] px-4 text-sm font-semibold text-[#0F1826] transition-colors hover:bg-[#67C6BE] focus:outline-none focus:ring-2 focus:ring-[#A6E0DB] focus:ring-offset-2 focus:ring-offset-[#0F1826]"
          >
            <LogIn className="h-4 w-4" />
            Login
          </Link>
          <Link
            to="/register"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-[#2A3954] bg-[#152036] px-4 text-sm font-semibold text-white transition-colors hover:bg-[#1D2C46] focus:outline-none focus:ring-2 focus:ring-[#A6E0DB] focus:ring-offset-2 focus:ring-offset-[#0F1826]"
          >
            <UserPlus className="h-4 w-4" />
            Sign up
          </Link>
        </div>

        <p className="mt-5 text-xs text-[#718096]">
          Sign up requires an invitation code.
        </p>
      </div>
    </main>
  );
}
